import { render, staticRenderFns } from "./usappbkdatamanagerver.vue?vue&type=template&id=6a38234e&scoped=true&"
import script from "./usappbkdatamanagerver.vue?vue&type=script&lang=js&"
export * from "./usappbkdatamanagerver.vue?vue&type=script&lang=js&"
import style0 from "./usappbkdatamanagerver.vue?vue&type=style&index=0&id=6a38234e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a38234e",
  null
  
)

export default component.exports